import type {IProxiedHttpResponse} from '../../data-layer-client/FrameMessenger';

import type {Filter} from './types';
import {authStore} from '../authentication/AuthenticationStore';
import {notifyExternalPayoutAccountKeyAvailable} from '../DataLayer';

export const externalAccountKeyFilter: Filter = {
  matchers: [
    {
      urlPath: /\/v1\/connect\/auth\/requires_external_account_verification/,
      method: 'POST',
    },
    {
      urlPath: /\/v1\/connect\/external_account_challenge/,
      method: 'POST',
    },
    {
      urlPath: /\/v1\/connect\/identity_challenge/,
      method: 'GET',
    },
    {
      urlPath: /\/v1\/connect\/external_account_code_verify/,
      method: 'POST',
    },
  ],

  filterResponse: (response: IProxiedHttpResponse) => {
    let body;
    if (response.body && typeof response.body === 'string') {
      try {
        body = JSON.parse(response.body);
      } catch (e) {}
    }

    if (body?.key) {
      authStore.persist({apiKey: body.key, type: 'external_account'});
      notifyExternalPayoutAccountKeyAvailable(body.key);
      body.key = 'REDACTED';
      return Object.assign(response, {body: JSON.stringify(body)});
    } else {
      return response;
    }
  },
};
